function injectProp(target, propName, get, set) {
  Object.defineProperty(target, propName, {
    get,
    set,
    enumerable: true
  });
  return target;
}
export {
  injectProp
};
//# sourceMappingURL=inject-obj-prop.es.js.map
